<div class="items-center justify-start overflow-hidden rounded-xl border border-slate-200 bg-white pl-2 shadow-sm"
     [style.height]="viewState().h"
     [style.width]="viewState().w">
    <img class="max-h-full max-w-full object-contain p-2"
        [src]="viewState().url" [alt]="viewState().alt">
</div>


